import { BrowserRouter } from 'react-router-dom';
import React from 'react';
// routes
import { AllRoutes } from './index';
import {AuthProvider} from '../hooks/AuthProvider';
import {PrimeReactProvider} from "primereact/api";
import {AssetProvider} from "../hooks/AssetsProvider";
import { PollingProvider } from '../hooks/checkLogin';

const Routes = () => {
  return (
    
       <PrimeReactProvider>
          <BrowserRouter>
          <PollingProvider>
            <AuthProvider>
              <AssetProvider>
              <AllRoutes />
              </AssetProvider>
            </AuthProvider>
            </PollingProvider>
          </BrowserRouter>
       </PrimeReactProvider>
       
  );
};

export default Routes;
